<template>
<app-content>
  <h1>{{ $t('content.faq.title') }}</h1>
  <div class="card">
    <h3>Er de beregnede kørselstider nøjagtige for studentervogne?</h3>
    <p>Ja, som udgangspunkt. Der er dog stor forskel på, hvor hurtigt hver enkelt studentervogn kører.
      Tripply's algoritme bliver hele tiden finjusteret til at efterligne en gennemsnitlig studentervogns kørsel.
      Tripply tager udgangspunkt i en studentervogn der kører med hastigheder omkring 60-75% af de maksimal tilladte hastigheder (60 km/t på landevej og 40 km/t ved tættere bebyggelse).
      </p>
    <p><b>Forhør jer altid med vognselvskabet om rutens varighed er realistisk!</b></p>
  </div>
  <div class="card">
    <h3>Hvor mange pause-minutter skal jeg bruge til studenterkørsel?</h3>
    <p>Det er forventeligt, at <b><u>minimum</u> 5 af de angivne minutter</b> bliver opbrugt at af- og påstigning. Det anbefales derfor, at der lægges <b>5 minutter</b>
      til den ønskede pause-længde. Hvis I eksempelvis ønsker at holde pause i <b>10 minutter</b> så angiv <b>15 minutter</b> i ruteberegneren.
    </p>
  </div>
  <div class="card">
    <h3>Er de beregnede kørselstider nøjagtige for biler?</h3>
    <p>Ja, men der tages dog ikke højde for trafik.</p>
  </div>
  <div class="card">
    <h3>Hvordan beregnes ruten?</h3>
    <p>Vi beregner selv ruten ved hjælp af open-source software, der kører på vores egen server. Vi benytter ikke 3. parter til beregningen.</p>
  </div>
  
</app-content>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import AppContent from '@/components/layout/AppContent.vue'
export default defineComponent({
  components: { AppContent }
})
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: 1rem;
}
</style>